import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { Edit, Save } from "@material-ui/icons";
// import JudgesDesignationInput from "./JudgesDesignationInput";

const MasterTable = ({ data, onAddRow, onEditRow, onDeleteRow, classes, selectedLabel, selectedMasterType, SUBJECT_CATEGORY_CHOICES }) => {
  const [editIndex, setEditIndex] = useState(-1); // Current row being edited
  const [editRow, setEditRow] = useState(null); // Temporary state for edited row

  const handleEditClick = (index) => {
    setEditIndex(index);
    setEditRow({ ...data[index] }); // Populate temporary state with row data
  };

  const handleFieldChange = (field, value) => {
    setEditRow((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveRow = () => {
    if (editRow && editRow.id) {
      const { id, code, name, designation, category, amount } = editRow;
      onEditRow(selectedMasterType, id, { code, name, designation, category, amount });
      setEditIndex(-1);
      setEditRow(null);
    }
  };

  console.log(selectedLabel,'selectedlabel')
  return (
    <TableContainer component={Paper} sx={{ marginTop: 4 }}>
      <Table>
        {/* Table Head */}
        <TableHead>
          <TableRow>
            <TableCell className={classes.noBorders}>{`${selectedLabel} ${selectedLabel==='Subjects'?'ID':'Code'}`}</TableCell>
            {selectedLabel === 'Case Type' && (
              <>
                <TableCell className={classes.noBorders}>{`Type`}</TableCell>
                <TableCell className={classes.noBorders}>{`${selectedLabel} Short Name`}</TableCell>
              </>
            )}
            {selectedLabel === 'Judges' && 
                <TableCell className={classes.noBorders}>{`${selectedLabel} Designation`}</TableCell>
            }
            <TableCell className={classes.noBorders}>{`${selectedLabel} Name`}</TableCell>
            {selectedLabel === 'Case Type' && (
              <>
                <TableCell className={classes.noBorders}>{`Fees`}</TableCell>
              </>
            )}
            <TableCell className={classes.noBorders}>Modify</TableCell>
            <TableCell className={classes.noBorders}>Delete</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
                <TableCell className={classes.noBorders}>
                    {row?.id}
                </TableCell>
                {selectedLabel === "Case Type" && (
                  <>
                    <TableCell className={classes.noBorders}>
                      { editIndex === index ? (
                        <TextField
                          fullWidth
                          required
                          label='Select'
                          variant='outlined'
                          select
                          size="small"
                          value={editRow?.type}
                          onChange={(e) => handleFieldChange("type", e.target.value)}
                          SelectProps={{
                            native: true,
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        >
                          <option >-Select-</option>
                          <option value="main_case">Main Case</option>
                          <option value="application">Application</option>
                          <option value="document">Document</option>
                        </TextField>
                        ) : (
                        row?.type
                      )}
                    </TableCell>
                    <TableCell className={classes.noBorders}>
                        { editIndex === index ? (
                            <TextField
                                value={editRow.code}
                                onChange={(e) => handleFieldChange("code", e.target.value)}
                                variant="outlined"
                                size="small"
                            />
                            ) : (
                            row?.code
                        )}
                    </TableCell>
                  </>
                )}
                {/* {selectedLabel === "Judges" && (
                    <TableCell className={classes.noBorders}>
                        { editIndex === index ? (
                            <JudgesDesignationInput
                              value={editRow.designation}
                              onChange={(e) => handleFieldChange("designation", e.target.value)}
                              size="small"
                            />
                            ) : (
                            row?.designation
                        )}
                    </TableCell>
                )} */}
                {(selectedLabel === 'Subjects') && (
                  <TableCell className={classes.noBorders}>
                    {editIndex === index ? (
                      <FormControl required fullWidth margin="none" size="small" variant="outlined">
                        <InputLabel>Category</InputLabel>
                        <Select
                          name="category"
                          label='Category'
                          value={editRow?.category}
                          onChange={(e) => handleFieldChange("category", e.target.value)}
                          displayEmpty
                          fullWidth
                        >
                          {SUBJECT_CATEGORY_CHOICES?.map((subjectCategory, index) => (
                            <MenuItem key={index} value={subjectCategory.value}>
                              {subjectCategory.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                      SUBJECT_CATEGORY_CHOICES?.find(category => category?.value === row?.category)?.label
                    )}
                  </TableCell>
                )}
                <TableCell className={classes.noBorders}>
                    {editIndex === index ? (
                        <TextField
                            value={editRow.name}
                            onChange={(e) => handleFieldChange("name", e.target.value)}
                            variant="outlined"
                            size="small"
                        />
                        ) : (
                        row?.name
                    )}
                    {/* {row?.name} */}
                </TableCell>
              {selectedLabel === "Case Type" && (
                <TableCell className={classes.noBorders}>
                  { editIndex === index ? (
                      <TextField
                          value={editRow?.amount}
                          onChange={(e) => handleFieldChange("amount", e.target.value)}
                          variant="outlined"
                          size="small"
                      />
                      ) : (
                      row?.amount
                  )}
                </TableCell>
              )}
              <TableCell className={classes.noBorders}>
                {editIndex === index ? (
                  <IconButton onClick={() => handleSaveRow(index)} className={classes.tableBtn}>
                    Save <Save style={{height:18, width:18}} />
                  </IconButton>
                ) : (
                  <IconButton title="Modify" aria-label="Modify" onClick={() => handleEditClick(index)}>
                    <Edit style={{height:18, width:18}} />
                  </IconButton>
                )}
              </TableCell>
              <TableCell className={classes.noBorders}>
                <IconButton title="Delete" aria-label="Delete" onClick={() => onDeleteRow(row?.id)}>
                  <DeleteOutlineIcon style={{height:18, width:18}} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MasterTable;
